
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import useCapabilities from '@/resources/capabilities';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import { POSITION } from 'vue-toastification';
import PurchaseAuthorization from '@/api/objects/PurchaseAuthorization';
import ThePatientPurchaseAuthorizationShow
  from '@/views/patient/expedients/purchaseAuthorization/parts/ThePatientPurchaseAuthorizationShow.vue';

export default defineComponent({
  name: 'ThePatientConsultationView',
  components: {
    ThePatientPurchaseAuthorizationShow,
    VButton,
  },
  setup() {
    return {
      ...useCapabilities(),
    };
  },
  data() {
    return {
      modalToShow: null as null | string,
    };
  },
  computed: {
    ...mapState('patient/expedient', ['currentExpedient']),
    ...mapState('patient/expedient/purchaseAuthorization', ['purchaseAuthorizations']),
    ...mapState('patient/expedient/consultation', ['currentConsultation']),
    ...mapState('treatment', ['currentTreatment']),
    ...mapState('app', ['formsSettings']),
  },
  methods: {
    consultationAuthorizations() {
      const purchases = [] as PurchaseAuthorization[];

      this.purchaseAuthorizations.forEach((purchaseAuthorization: PurchaseAuthorization) => {
        if (purchaseAuthorization.consultationId === this.currentConsultation.id) {
          purchases.push(purchaseAuthorization);
        }
      });

      return purchases;
    },
    via() {
      const via = this.formsSettings.consultation_via_options.find((o) => o.key === this.currentConsultation.via);

      return via.label;
    },
    type() {
      const type = this.formsSettings.consultation_type_options.find((o) => o.key === this.currentConsultation.type);

      return type.label;
    },
    status(value) {
      switch (value) {
        case 'pending':
          return this.$t('Pendiente');
        case 'finalized':
          return this.$t('Finalizado');
        case 'deprecated':
          return this.$t('Caducado');
        case 'disabled':
          return this.$t('Deshabilitada');
        default:
          return value;
      }
    },
    async loadPurchaseAuthorizations() {
      try {
        await this.$store.dispatch('patient/expedient/refreshPurchaseAuthorizations', {
          expedientId: this.currentExpedient.id,
        });
      } catch (e) {
        this.$toast.error(this.$t('Ha ocurrido un error al cargar las autorizaciones de compra'), {
          position: POSITION.BOTTOM_RIGHT,
        });
      }
    },
    async setCurrentPurchase(purchaseAuthorization) {
      await this.$store.dispatch('patient/expedient/purchaseAuthorization/getCurrentPurchaseAuthorization', {
        purchaseAuthorization,
      });
    },
  },
});
